import axios from 'axios';
import { getTabToken } from './tabSession';

const backend = new URL(process.env.REACT_APP_BACKEND_URL);
const unsafe = method => !['GET', 'HEAD', 'OPTIONS'].includes((method || 'GET').toUpperCase());
const apiUrl = input => {
  const url = new URL(typeof input === 'string' ? input : input.url, window.location.origin);
  return url.pathname.startsWith('/api/') && [backend.origin, window.location.origin].includes(url.origin);
};

if (!window.__necsCsrfTransportInstalled) {
  window.__necsCsrfTransportInstalled = true;
  const original = window.fetch.bind(window);
  // Fetch for each write to remain correct after login/impersonation in another tab.
  const token = async () => {
    const response = await original(`${backend.origin}/api/auth/csrf`, { credentials: 'include', cache: 'no-store' });
    return response.ok ? (await response.json()).csrf_token : null;
  };
  window.fetch = async (input, init = {}) => {
    const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined));
    const method = init.method || (input instanceof Request ? input.method : 'GET');
    if (!apiUrl(input) || !unsafe(method) || getTabToken()) return original(input, init);
    const csrf = await token();
    if (csrf) headers.set('X-CSRF-Token', csrf);
    return original(input, { ...init, headers });
  };
  axios.interceptors.request.use(async config => {
    if (!apiUrl(new URL(config.url, config.baseURL || window.location.origin).toString()) || !unsafe(config.method) || getTabToken()) return config;
    const csrf = await token();
    if (csrf) config.headers['X-CSRF-Token'] = csrf;
    return config;
  });
}